import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
    apiKey: 'AIzaSyDUe06CRxF5soVx3z_6UvjfzejLqwIHU4g',
    authDomain: 'tracking-app-3a031.firebaseapp.com',
    projectId: 'tracking-app-3a031',
    storageBucket: 'tracking-app-3a031.firebasestorage.app',
    messagingSenderId: '939082941573',
    appId: '1:939082941573:web:03c06f2c9ea48b746c15ec',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'europe-west2'); // Specify the region